import landingSlider from "./components/landing/landing-slider";
import benefitsAnimation from "./components/landing/landing-benefits-animation";
import landingInstallationAnimation from "./components/landing/landing-installation-anim";
import observerAnimationElements from "./components/landing/observerAnimationElements";
import landing360View from "./components/landing/landing-360";

$(document).ready(function () {
    landing360View();
    landingSlider();
    benefitsAnimation();
    landingInstallationAnimation();
    observerAnimationElements('.js-trigger-section', '.landing-promo__item__inner');
    // observerAnimationElements('.js-landing-second-container ', '.landing-guarantee','normal');
});